export const environment = {
    BASE_URL: 'https://merchant-api-live-v2.onepay.lk/api',
    BASE_URL_NEW: 'https://oneticket-uat.onepayapi.lk/api/v3/',
    aws: 'https://storage.googleapis.com/oneticket/',
    organizerEmail: 'info@onepay.lk',
    // base_live : "https://oneticket.onepay.lk/api/v3/",
  };
  export const base_url_new = "https://oneticket-live.onepayapi.lk/api/v3/";
  //export const base_url_new = "http://localhost:8000/api/v3/";
